import { injectable } from 'inversify';

@injectable()
export class CurrentClientUserSelectionLocalStorageService {
  private readonly storageKey = 'cockpit-client::selected-client-id';

  public saveSelectedClientId(clientId: string): void {
    if (!this.canUseLocalStorage()) {
      return;
    }

    window.localStorage.setItem(this.storageKey, clientId);
  }

  public getSelectedClientId(): string | null {
    if (!this.canUseLocalStorage()) {
      return null;
    }

    return window.localStorage.getItem(this.storageKey);
  }

  public clearSelectedClientId(): void {
    if (!this.canUseLocalStorage()) {
      return;
    }

    window.localStorage.removeItem(this.storageKey);
  }

  private canUseLocalStorage(): boolean {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}
